// extracted by mini-css-extract-plugin
module.exports = {"item":"LearningMenuItem_item__3k1gW","icon":"LearningMenuItem_icon__2on0j","info":"LearningMenuItem_info__2gWnV","active":"LearningMenuItem_active__1Up82"};